import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { AuctionUWContent, CompleteAuctionModal } from '../auctionUnderwrite';
import { selectedAuctionTxnOppsSelector } from 'store/selectors';
import { LoadingOverlayWrapper } from 'components/layout';
import { Constants } from 'utilities/constants';

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateAreas: `'content proforma'`,
    gridTemplateColumns: '1fr auto',
    // height: 'calc(100vh - 48px)',
    width: '100%'
  },
  content: {
    gridArea: 'content',
  },
  resizableContainer: {
    height: 'calc(100vh - 48px)'
  },
  proformaOpen: {
    gridArea: 'proforma',
    height: '100%',
    backgroundColor: '#fff',
    borderLeft: '2px solid rgba(0, 0, 0, 0.12)',
    overflowY: 'auto',
    paddingBottom: '10px',
  },
  proformaClosed: {
    gridArea: 'proforma',
    width: '30px',
    height: '100%',
    backgroundColor: '#e6e6e6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  loadingOverlay: {
    display: 'flex',
    width: '100%'
  }
});

const AuctionUW = ({ classes, location, selectedTask,
  viewValuationDialogIsOpen, isUserOwnedTask, isFetchingAuctionUWData }) => {

  useEffect(() => {
    let abortController = new AbortController(); 
    // const taskId = location.pathname.split(Constants.Routes.UNDERWRITE_AUCTION + '/')[1];

    return () => {  
      abortController.abort();  
      }
  }, [location]);

  return (
    <LoadingOverlayWrapper
      className={classes.loadingOverlay}
      active={isFetchingAuctionUWData && !viewValuationDialogIsOpen}
      message={'Fetching auction data...'}
    >
      {/* <div className={classes.container}> */}
      <AuctionUWContent selectedTask={selectedTask} isUserOwnedTask={isUserOwnedTask} />
      <CompleteAuctionModal selectedTask={selectedTask} />
      {/* </div> */}
    </LoadingOverlayWrapper>
  );
};


const mapStateToProps = state => {
  const isUserOwnedTask = selectedAuctionTxnOppsSelector(state)?.[0]?.auctionOwnerUserId === state.appState.user.id;
  return {
    selectedTask: state.selectedTask,
    viewValuationDialogIsOpen: state.auctionUWState.viewValuationDialogIsOpen,
    isUserOwnedTask: isUserOwnedTask,
    isFetchingAuctionUWData: state.auctionUWState.isFetchingAuctionUWData
  }
};
const mapDispatchToProps = dispatch => ({
});

export default compose(
  withRouter,
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AuctionUW);
